import { Component } from '@angular/core';
import { FormApiService } from '@app/core/services/form-api.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MeteringPointService, ReconnectDto } from '@app/api/dmc';

import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { AlertService } from '@app/core/services/alert.service';
import { TranslatePipe } from '@ngx-translate/core';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-reconnect-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    TranslatePipe
  ],
  templateUrl: './reconnect-modal.component.html',
  styleUrl: './reconnect-modal.component.css'
})
export class ReconnectModalComponent implements HasUnsavedChanges {

  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl(null, Validators.required),
    occurrence: new FormControl(null, Validators.required),
    forceReconnect: new FormControl(null),
  });

  /** ID **/
  public id?: string;

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meteringPointService: MeteringPointService,
    private readonly alertService: AlertService,
  ) {
    this.alertService.open('modal', 'info','meteringpoint.reconnect.reconnectInfo');
  }

  public submit(): void {
    if (this.id) {
      /** Set ID **/
      this.form.get('meteringPointIdentification')?.setValue(this.id);

      this.formApiService.submit<ReconnectDto>(
        this.form,
        (data) => this.meteringPointService.meteringPointReconnectPut(data),
        {
          preprocess: (data: any) => ({
            ...data,
            forceReconnect: false
          }),
          successMessage: 'Genåbning gemt',
          closeModal: true
        }
      )
    }
  }

}
